import { Injectable } from '@angular/core';
import { CommonapiService } from '../../Service/Commonapi.service';

@Injectable({
  providedIn: 'root'
})
export class AppNotificationService {

constructor(public api: CommonapiService) { }
async GetNotificationCount(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanNotificationCount`,obj,isformupload);    
}
}
